import Immutable from 'immutable';

const Content: {
  id?: string,
  name: string | null,
  printable: boolean | null,
  processingStepGroup: string,
  processingStepType: string
} = {
  id: undefined, // TODO FileInfoProcessingStep should have an id that is set by the server
  name: null,
  printable: false,
  processingStepGroup: '',
  processingStepType: ''
};

class FileInfoProcessingStep extends Immutable.Record(Content) {
}

export default FileInfoProcessingStep;
